var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9551 29.2021C23.4108 29.2021 29.4551 23.1579 29.4551 15.7021C29.4551 8.2464 23.4108 2.20215 15.9551 2.20215C8.49933 2.20215 2.45508 8.2464 2.45508 15.7021C2.45508 23.1579 8.49933 29.2021 15.9551 29.2021ZM15.9551 30.7021C24.2396 30.7021 30.9551 23.9866 30.9551 15.7021C30.9551 7.41765 24.2396 0.702148 15.9551 0.702148C7.67058 0.702148 0.955078 7.41765 0.955078 15.7021C0.955078 23.9866 7.67058 30.7021 15.9551 30.7021Z",
    fill: "#212529"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.70508 15.7021C7.70508 15.5032 7.7841 15.3125 7.92475 15.1718C8.0654 15.0312 8.25617 14.9521 8.45508 14.9521H23.4551C23.654 14.9521 23.8448 15.0312 23.9854 15.1718C24.1261 15.3125 24.2051 15.5032 24.2051 15.7021C24.2051 15.9011 24.1261 16.0918 23.9854 16.2325C23.8448 16.3731 23.654 16.4521 23.4551 16.4521H8.45508C8.25617 16.4521 8.0654 16.3731 7.92475 16.2325C7.7841 16.0918 7.70508 15.9011 7.70508 15.7021Z",
    fill: "#212529"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLessIcon);
export default __webpack_public_path__ + "static/media/LessIcon.68f35b2cf78fff7751fa6c4e4ff1c84f.svg";
export { ForwardRef as ReactComponent };